import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Benefits from './components/Benefits';
import Process from './components/Process';
import HouseForm from './components/HouseForm';

const App: React.FC = () => {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Benefits />
      <Process />
      <HouseForm />
      <footer className="footer">
        <div className="container">
          <p>&copy; 2025 CasaDirecta. Compramos casas directamente de particulares.</p>
          <p>📧 info@casadirecta.com | 📱 600 123 456</p>
        </div>
      </footer>
    </div>
  );
};

export default App;